import React, { useEffect, useState } from "react";
import { Breadcrumb, PageHeader, Select, Form, Table, Tooltip } from "antd";
import Page from "_components/Page";
import { Link } from "react-router-dom";

import { productForecastService } from "_services";

import Search from "./Search";

function ForecastList({ history, match }) {
  const { path } = match;
  const defaultExpandable = {};
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [forecasts, setforecasts] = useState([]);
  const [FilterdData, SetFilteredData] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [expandable, setExpandable] = useState(defaultExpandable);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useState("");

  const { Option } = Select;

  const handleSearchResults = (results, totalRecords, searchParams) => {
    setforecasts(results);
    setTotalRecords(totalRecords);
    setSearchParams(searchParams);
    setPageNumber(1);
    setIsLoading(false);
  };

  function getAllProductForCasts() {
    setIsLoading(true);
    productForecastService
      .getAll()
      .then((response) => {
        setforecasts(
          response.content.map((content) => ({ ...content, key: content.id }))
        );
      })
      .catch((error) => {
        setError(`${error.message ?? "Please fix errors"}`);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getAllProductForCasts();
  }, []);

  const materialTableColumns = [
    {
      title: "HS Code",
      dataIndex: "product.code",
      key: "hsCode",
      width: "8%",
      render: (text, record) => (
        <Link to={`${path}/${record.id}/summery`}>{record.product.code}</Link>
      ),
    },
    {
      title: "Forecast For",
      dataIndex: "product.name",
      key: "productName",
      width: "25%",
      render: (text, record) => record.product.name,
    },

    {
      title: "Product Code",
      dataIndex: ["product", "secondaryCode"],
      key: "secondaryCode",
      width: "8%",
      render: (text, record) => (
        <Tooltip title={text}>{text?.substring(0, 8)}</Tooltip>
      ),
    },
    {
      title: "Forecast Quantity",
      dataIndex: "forecastQuantity",
      key: "forecastQuantity",
      width: "8%",
      render: (text, record) => record.forecastQuantity ?? 0,
    },
    {
      title: "Currency",
      dataIndex: "currency.code",
      key: "currency.code",
      width: "5%",
      render: (text, record) => record.currency.code ?? "",
    },
    {
      title: "Exchange Rate",
      dataIndex: "exchangeRate ",
      key: "exchangeRate",
      width: "8%",
      render: (text, record) => record.exchangeRate ?? 0,
    },
    {
      title: `Total Cost(LKR)`,
      dataIndex: "totalCost ",
      key: "totalCost",
      width: "8%",
      render: (text, record) => Number(record.totalCost).toFixed(2) ?? 0,
    },
  ];
  const getItems = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setIsLoading(true);
    productForecastService
      .search(`${searchParams}${paginationParams}`)
      .then((data) => {
        setforecasts(data.content);

        setTotalRecords(data.pagination.totalRecords);
        setPageNumber(pageNumber);
        setIsLoading(false);
      })
      .catch((error) => {
        //this.setState({ loading: false, error });
        setIsLoading(false);
      });
  };
  const handlePaginateChange = (pageNumber, pageSize) => {
    getItems(pageNumber, pageSize);
  };
  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom/boms">Finished Goods</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom/forecasts">Forecast List</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Page inner error={error}>
          <Search
            showSearchLoading={setIsLoading}
            onSearchResults={handleSearchResults}
          />

          <Table
            bordered
            columns={materialTableColumns}
            dataSource={forecasts}
            size="small"
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: false,
              onChange: handlePaginateChange,
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
}

export default ForecastList;
